import { Component } from "@angular/core";

import { UserblockService } from "./userblock.service";
import { ActivatedRoute, RouterLinkActive, RouterLink } from "@angular/router";

import { UserFacadeService } from "src/app/core/facades/userfacade/userfacade.service";
import { NgIf } from "@angular/common";
import { TranslatePipe } from "@ngx-translate/core";

@Component({
  selector: "app-userblock",
  templateUrl: "./userblock.component.html",
  styleUrls: ["./userblock.component.scss"],
  imports: [NgIf, RouterLinkActive, RouterLink, TranslatePipe],
})
export class UserblockComponent {
  user: any;
  currentUser;
  constructor(
    public userblockService: UserblockService,
    private route: ActivatedRoute,
    private userFacadeService: UserFacadeService,
  ) {
    this.currentUser = this.userFacadeService.user.getValue();
    this.user = {
      picture: "assets/img/user/hxa_user_avatar.png",
    };
  }

  userBlockIsVisible() {
    return this.userblockService.getVisibility();
  }
}
